/**
 * PlayerEditDialog - Dialog for editing player name and gender
 */

import type { Component, ChangeEvent } from 'react';

const React = (window as any).React;
const ReactComponent = React.Component;

// Forward declarations
declare const TheGame: any;

interface PlayerEditDialogProps {
    onSave: (name: string, gender: string) => void;
    onCancel: () => void;
}

interface PlayerEditDialogState {
    name: string;
    gender: string;
}

class PlayerEditDialog extends ReactComponent<PlayerEditDialogProps, PlayerEditDialogState> {
    constructor(props: PlayerEditDialogProps) {
        super(props);
        const player = TheGame?.Player;
        this.state = {
            name: player?.Name || player?.PlayerName || '',
            gender: player?.Gender || player?.PlayerGender || ''
        };
    }

    handleSave = (): void => {
        this.props.onSave(this.state.name, this.state.gender);
    };

    handleCancel = (): void => {
        this.props.onCancel();
    };

    render(): any {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) return null;

        return React.createElement(DialogComponent, {
            title: 'Edit Player',
            onClose: this.handleCancel,
            actionButtons: React.createElement(React.Fragment, null,
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.handleCancel
                }, 'Cancel'),
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.handleSave
                }, 'Save')
            ),
            closeOnBackdropClick: false
        },
            React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '16px' } },
                React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '8px' } },
                    React.createElement('label', { style: { fontWeight: 'bold' } }, 'Name:'),
                    React.createElement('input', {
                        type: 'text',
                        value: this.state.name,
                        onChange: (e: ChangeEvent<HTMLInputElement>) => {
                            this.setState({ name: e.target.value });
                        },
                        style: {
                            padding: '8px',
                            fontFamily: 'var(--font-game-text)',
                            fontSize: '14px',
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            borderRadius: '4px',
                            background: 'var(--main-bg-color)',
                            color: 'var(--main-text-color)'
                        }
                    })
                ),
                React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '8px' } },
                    React.createElement('label', { style: { fontWeight: 'bold' } }, 'Gender:'),
                    React.createElement('select', {
                        value: this.state.gender,
                        onChange: (e: ChangeEvent<HTMLSelectElement>) => {
                            this.setState({ gender: e.target.value });
                        },
                        style: {
                            padding: '8px',
                            fontFamily: 'var(--font-game-text)',
                            fontSize: '14px',
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            borderRadius: '4px',
                            background: 'var(--main-bg-color)',
                            color: 'var(--main-text-color)'
                        }
                    },
                        React.createElement('option', { value: 'Male' }, 'Male'),
                        React.createElement('option', { value: 'Female' }, 'Female'),
                        React.createElement('option', { value: 'Other' }, 'Other')
                    )
                )
            )
        );
    }
}

(window as any).PlayerEditDialog = PlayerEditDialog;
export default PlayerEditDialog;
